import Card from "antd/es/card";
import Text from "antd/es/typography/Text";
import styled from "styled-components";

export const SelectorContainer = styled.div`
  ${({ theme }) => `
  padding: 0 ${theme.paddingContentHorizontalLG}px;
  margin: 0 auto;
`}
`;

export const TypeGrid = styled.div`
  ${({ theme, }) => `
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: ${theme.margin}px;
  margin-top: ${theme.marginLG}px;
`}
`;

export const TypeCard = styled(Card)<{ $selected: boolean }>`
  ${({ theme, $selected }) => `
  cursor: pointer;
  transition: all ${theme.motionDurationMid} ${theme.motionEaseInOut};
  border: ${theme.lineWidth}px solid
    ${$selected ? theme.colorPrimary : theme.colorBorder};

  &:hover {
    border-color: ${theme.colorPrimaryHover};
    transform: translateY(-2px);
    box-shadow: ${theme.boxShadow};
  }

  .ant-card-body {
    text-align: center;
    padding: ${theme.paddingSM}px;
  }
`}
`;

export const IconWrapper = styled.div`
  ${({ theme }) => `
  font-size: ${theme.sizeLG}px;
  margin-bottom: ${theme.marginSM}px;
  line-height: 1;
`}
`;

export const CardTitle = styled(Text)`
  ${({ theme }) => `
  display: block;
  font-size: ${theme.fontSizeLG}px;
  font-weight: ${theme.fontWeightStrong}px;
  margin-bottom: ${theme.marginSM}px;
`}
`;

export const CardDescription = styled(Text)`
  ${({ theme }) => `
  display: block;
  color: ${theme.colorTextSecondary};
  font-size: ${theme.fontSizeSM}px;
`}
`;
